import { render, staticRenderFns } from "./ViewModeBoard.vue?vue&type=template&id=1788af35&"
import script from "./ViewModeBoard.vue?vue&type=script&lang=js&"
export * from "./ViewModeBoard.vue?vue&type=script&lang=js&"
import style0 from "./ViewModeBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports